<script lang="ts" setup>
import EventCalendarView from '@/domains/investor/event-calendar/components/EventCalendarView/EventCalendarView.vue'

definePageMeta({
  layout: 'investor',
})

const { t, locale } = useI18n()

useHead(() => ({
  title: t('pageTitles.investorEventCalendar.title'),
  meta: [
    {
      name: 'description',
      content: t('pageTitles.investorEventCalendar.meta'),
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: t(`pageTitles.investorEventCalendar.canonical.${locale.value}`),
    },
    {
      rel: 'alternate',
      hreflang: 'pl',
      href: t('pageTitles.investorEventCalendar.canonical.pl'),
    },
    {
      rel: 'alternate',
      hreflang: 'en',
      href: t('pageTitles.investorEventCalendar.canonical.en'),
    },
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: t('pageTitles.investorEventCalendar.canonical.pl'),
    },
  ],
}))
</script>

<template>
  <EventCalendarView />
</template>
